// extracted by mini-css-extract-plugin
export default {"buttonContainer":"RTeUI","alignToEdge":"dGd0S","buttonIcon":"slQ28","buttonCaption":"_3eY8O","buttonSpacer":"c4YWI"};